export const NEW_BADGE_WITH_GRADIENT_SRC =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/f8167f07b6b6330e59f6570a81dc1c5d-1750155286113/badge_new_gradient.png';
